import { stripeLabel } from '../../lib/tasks/taskTagDisplay';
import { cn } from '../../lib/cn';

/**
 * Bande colorée sur le bord gauche d'une tâche, une couleur par étiquette.
 * Au survol de la bande, une bulle donne le nom des étiquettes.
 * Le parent doit être en position relative.
 */
export function TaskTagStripe({
  tags,
  className,
}: {
  tags: { id: string; name: string; color: string }[];
  className?: string;
}) {
  if (tags.length === 0) return null;
  return (
    <span
      className={cn('group/stripe absolute inset-y-0 left-0 z-[1] w-2.5 cursor-help', className)}
      onClick={(e) => e.stopPropagation()}
      aria-label={`Étiquettes : ${stripeLabel(tags)}`}
    >
      <span className="absolute inset-y-0 left-0 flex w-1 flex-col overflow-hidden rounded-l-[inherit]">
        {tags.map((tag) => (
          <span key={tag.id} className="min-h-0 flex-1" style={{ background: tag.color }} />
        ))}
      </span>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-3 top-1/2 z-20 flex -translate-y-1/2 items-center gap-1.5 whitespace-nowrap rounded-md bg-cime-primary px-2 py-1 text-xs font-medium text-white opacity-0 shadow-md transition-opacity group-hover/stripe:opacity-100"
      >
        {tags.map((tag) => (
          <span key={tag.id} className="inline-flex items-center gap-1">
            <span className="h-2 w-2 rounded-full ring-1 ring-white/40" style={{ background: tag.color }} />
            {tag.name}
          </span>
        ))}
      </span>
    </span>
  );
}
